import { AdCodeCopyUrlButton } from 'components/AdCodeCopyUrlButton'
import { Button } from 'components/Button'
import { adCodeStrings, commonStrings } from 'constants/strings'
import type { TAdCodeListItem } from 'types'

type Props = {
  adCode: TAdCodeListItem
  onCopyUrl: () => void
  onToggleArchive: (adCode: TAdCodeListItem) => void
  archivingId?: number
}

export function AdCodeActions({
  adCode,
  onCopyUrl,
  onToggleArchive,
  archivingId,
}: Props) {
  return (
    <div className="flex min-w-0 flex-wrap items-center justify-end gap-2">
      {adCode.url && (
        <AdCodeCopyUrlButton
          url={adCode.url}
          idleLabel={commonStrings.actions.copy}
          variant="outline"
          onClick={(event) => event.stopPropagation()}
          onCopied={onCopyUrl}
        />
      )}
      <Button
        type="button"
        size="sm"
        variant="outline"
        loading={archivingId === adCode.id}
        disabled={archivingId !== undefined}
        onClick={(event) => {
          event.stopPropagation()
          onToggleArchive(adCode)
        }}
      >
        {adCode.status === 'ACTIVE'
          ? adCodeStrings.detail.archive
          : adCodeStrings.detail.unarchive}
      </Button>
    </div>
  )
}

export function AdCodeEditButton({
  adCodeId,
  onEdit,
}: {
  adCodeId: number
  onEdit: (adCodeId: number) => void
}) {
  return (
    <Button
      type="button"
      size="sm"
      className="shrink-0"
      onClick={(event) => {
        event.stopPropagation()
        onEdit(adCodeId)
      }}
    >
      {adCodeStrings.detail.edit}
    </Button>
  )
}
